<template>
	<header class="view-venue-header primary-header">
		<div class="venue-info">
			<h3 class="name">{{ venueModel.getName() }}</h3>
			<p class="address">{{ venueModel.getShortAddress() }}</p>
		</div>

		<div class="open-closed" v-if="showOpenClosed">
			<span class="is-open detail tag badge type-danger" v-if="venueModel.isOpenNow()">Open</span>
			<span class="is-closed detail tag badge type-danger" v-else>Closed</span>
		</div>

		<div class="favorite" v-if="showFavorite">
			<ChalkyReactionFavorite
				class="pull-right"
				data-analytics-event="place:favorite"
				v-bind:fetchRemote="true"
				v-bind:model="venueModel"
			/>
		</div>
	</header>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays the primary header for a venue with name, address, open/closed status, and favorite button.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueHeader extends ViewBase {
		/**
		 * The venue model containing header data
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		/**
		 * Whether to show the favorite button
		 *
		 * @type boolean
		 */
		@Prop({
			default: false,
		})
		public showFavorite!: boolean;

		/**
		 * Whether to show the open/closed status
		 *
		 * @type boolean
		 */
		@Prop({
			default: false,
		})
		public showOpenClosed!: boolean;
	}
</script>

<style lang="scss">
	.view-venue-header {
		align-items: center;
		display: grid;
		gap: 0.5rem;
		grid-template-columns: 1fr auto;
		padding: 1rem;

		.venue-info .name {
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			display: -webkit-box;
			line-height: 1;
			margin-bottom: 0.25rem;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.venue-info .address {
			color: var(--chalky-grey-2);
			overflow: hidden;
			text-overflow: ellipsis;
		}

		&.show-favorite {
			grid-template-columns: 1fr auto 60px;
		}
	}
</style>
